import { render } from "./ThemeSwitchButton.vue?vue&type=template&id=86e6320c&scoped=true"
import script from "./ThemeSwitchButton.vue?vue&type=script&lang=js"
export * from "./ThemeSwitchButton.vue?vue&type=script&lang=js"

import "./ThemeSwitchButton.vue?vue&type=style&index=0&id=86e6320c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e6320c"]])

export default __exports__